import React, { useState } from "react";
import "./StarRating.scss";

const StarRating = ({ totalStars = 5, rating, onRate, cls }) => {

  const [hover, setHover] = useState(0);  // Stores the hovered star index

  const handleClick = (index) => {
    if (onRate) {
      onRate(index);
    }
  };

  return (
    <div className={`star-rating  ${cls}`}>
      {Array.from({ length: totalStars }, (_, index) => {
        const starIndex = index + 1;
        return (
          <span
            key={index}
            className={`star ${starIndex <= (hover || rating) ? "filled" : ""}`}
            onClick={() => handleClick(starIndex)}
            onMouseEnter={() => setHover(starIndex)}
            onMouseLeave={() => setHover(0)}
          >
            ★
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;


// import React, { useState } from "react";
// import "./StarRating.scss";
// const StarRating = ({ totalStars = 5, onRate }) => {
//   const [rating, setRating] = useState(4); // Stores the current rating
//   const [hover, setHover] = useState(0);  // Stores the hovered star index
//   const handleClick = (index) => {
//     setRating(index);
//     if (onRate) {
//       onRate(index);
//     }
//   };
//   return (
//     <div className="star-rating">
//       {Array.from({ length: totalStars }, (_, index) => {
//         const starIndex = index + 1;
//         return (
//           <span
//             key={index}
//             className={`star ${starIndex <= (hover || rating) ? "filled" : ""}`}
//             onClick={() => handleClick(starIndex)}
//             onMouseEnter={() => setHover(starIndex)}
//             onMouseLeave={() => setHover(0)}
//           >
//             ★
//           </span>
//         );
//       })}
//     </div>
//   );
// };
// export default StarRating;
